import cn from "classnames";
import { useEffect } from "react";
import { usePageContextFunction } from "../../../context/PageContext";
import useWindowSize from "../../../hooks/useWindowSize";

import { func } from "../../../utils";
import { CountdownTimer, Text } from "../../atoms";

const Banner = ({
  title = "Banner Campaign Image",
  mode = "teaser",
  className = "",
}) => {
  const classNames = cn("banner", className);
  const { setPageMode } = usePageContextFunction();

  // const LAUNCH_DAY = 1 * 24 * 60 * 60 * 1000;
  const LAUNCH_DAY = 0;
  const NOW_IN_MS = new Date("March 4, 23 00:00:00 GMT+07:00").getTime();

  const launchDateCountdown = NOW_IN_MS + LAUNCH_DAY;
  const isCurrentLaunch = launchDateCountdown === NOW_IN_MS;
  useEffect(() => {
    if (launchDateCountdown <= 0) setPageMode("banner");
  }, [launchDateCountdown]);

  const { size } = useWindowSize();

  const mobileTableView = () => {
    return (size?.width || 0) <= 992;
  };

  const backdrop = ({ numofThunder }) => {
    return (
      <div className="banner__backdrop">
        {mode === "teaser" && (
          <img
            src={func.getStaticImg(`illustration/byU-logo.svg`)}
            alt={`byU-logo`}
            className={`byU-logo byu-logo--m`}
          />
        )}
        <div className="banner__backdrop--d">
          {Array.from(Array(numofThunder).keys()).map((_, i) => {
            return (
              <img
                key={i}
                src={func.getStaticImg(`illustration/thunder/thunder${i}.svg`)}
                alt={`thunder${i}`}
                className={`thunder${i}`}
              />
            );
          })}
        </div>
      </div>
    );
  };
  return (
    <div className={classNames}>
      <div className="banner__inner-header">
        {mode === "teaser" && (
          <img
            src={func.getStaticImg(`illustration/byU-logo.svg`)}
            alt={`byU-logo`}
            //className={`byU-logo`}
          />
        )}
      </div>

      <div
        style={{
          minHeight: mode === "teaser" ? "100vh" : "80vh",
        }}
        className={"banner__container"}
      >
        {/* -- image */}

        <div className="banner__img" />
        <div className="banner__img--m" />
        {backdrop({ numofThunder: 8 })}
        {/* -- package */}
        <div className="banner__content">
          <div className="banner__container">
            <div className="banner__inner">
              <div>
                <img
                  src={
                    mobileTableView()
                      ? func.getStaticImg(
                          `bg/${
                            mode === "banner"
                              ? "headline-teaser-blitar-mobile.png" //sementara gini dulu barangkali nanti berubah
                              : "headline-teaser-blitar-mobile.png"
                          }`
                        )
                      : func.getStaticImg(
                          `bg/${
                            mode === "teaser"
                              ? "headline-teaser-blitar.png" //sementara gini dulu barangkali nanti berubah
                              : "headline-teaser-blitar.png"
                          }`
                        )
                  }
                  alt={title}
                  className="banner__img__m banner__img__m__headline"
                />
                <div className="banner__left">
                  <Text
                    className="banner__subtitle"
                    weight="bold"
                    color="white"
                  >
                    {/* temporary gini dulu barangkali nanti ada pergantian wording lagi */}
                    {mode === "banner"
                      ? "Siapkan dukungan terbaik untuk tim futsal sekolahmu di Piala by.U Blitar!"
                      : "Siapkan dukungan terbaik untuk tim futsal sekolahmu di Piala by.U Blitar!"}
                  </Text>
                  <div className="banner__left--d">
                    {!isCurrentLaunch && (
                      <CountdownTimer targetDate={launchDateCountdown} />
                    )}

                    <div className="banner__img__title__location__container">
                      <img
                        src={func.getStaticImg(`illustration/pin-location.svg`)}
                        alt={"pin"}
                      />
                      <Text
                        color="white"
                        weight="bold"
                        size="medium"
                        className="banner__img__title__location__container__text"
                      >
                        GOR SOEKARNO HATTA
                      </Text>
                      <div className="banner__img__title__location__container__inner">
                        <div className="vertical-divider" />
                      </div>
                      <Text
                        color="white"
                        weight="bold"
                        size="medium"
                        className="banner__img__title__location__container__text"
                      >
                        Blitar, 4 - 12 Maret 2023
                      </Text>
                    </div>
                  </div>
                </div>
              </div>
              <div className="banner__left--m">
                {!isCurrentLaunch && (
                  <CountdownTimer targetDate={launchDateCountdown} />
                )}
              </div>
              <div className="banner__pkg">
                <div className="banner__img__d__blitar">
                  <img
                    src={func.getStaticImg(`illustration/piala-blitar.svg`)}
                    alt={"piala-byU"}
                    className="banner__img__m banner__img__jkt"
                    onClick={() => func.scrollTo("awards-section")}
                  />
                  <img
                    src={func.getStaticImg(`illustration/bolaKaki.svg`)}
                    alt={"bolaByu"}
                    className="banner__img__m banner__img__jkt_bola1"
                  />
                  <img
                    src={func.getStaticImg(`illustration/bolaKaki.svg`)}
                    alt={"bolaByu"}
                    className="banner__img__m banner__img__jkt_bola2"
                  />
                  <img
                    src={func.getStaticImg(`illustration/bolaKaki.svg`)}
                    alt={"bolaByu"}
                    className="banner__img__m banner__img__jkt_bola3"
                  />
                </div>
              </div>

              {mobileTableView() && (
                <>
                  <div className="banner__img__title__location__container">
                    <img
                      src={func.getStaticImg(`illustration/pin-location.svg`)}
                      alt={"pin"}
                    />
                    <Text
                      color="white"
                      weight="bold"
                      size="medium"
                      className="banner__img__title__location__container__text"
                    >
                      GOR SOEKARNO HATTA
                    </Text>
                  </div>
                  <div>
                    <Text
                      color="white"
                      weight="bold"
                      size="medium"
                      className="banner__img__title__location__container__text"
                    >
                      Blitar, 4 - 12 Maret 2023
                    </Text>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {mode === "banner" && (
          <>
            <svg
              className="banner__wave banner__wave--d"
              viewBox="0 0 1440 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1443 0C1416.08 8.52381 1386.89 17.8858 1355.04 26.2375C927.206 138.439 630.612 18.169 439.489 3.78182C248.367 -10.6054 115.239 17.829 -9.99998 59.0916V100H1443V0Z"
                fill="#F0F2F9"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_868_71760"
                  x1="1443"
                  y1="50"
                  x2="-10"
                  y2="49.9999"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#DAE8F0" />
                  <stop offset="0.333333" stop-color="white" />
                  <stop offset="0.740879" stop-color="#F9FBFD" />
                  <stop offset="1" stop-color="#DAE9F1" />
                </linearGradient>
              </defs>
            </svg>

            {/*mobile swoosh */}

            <svg
              className="banner__wave banner__wave--m"
              viewBox="0 0 375 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M374.999 0V56H0.000488281L0.000488281 52.0933C15.8049 32.3818 50.0563 24.6905 102.755 29.0191C110.132 29.6252 117.131 30.3502 123.806 31.1496L126.646 31.4966C127.587 31.6137 128.521 31.7322 129.448 31.852L132.213 32.2148C132.67 32.2759 133.126 32.3372 133.581 32.3988L136.291 32.7715L138.965 33.1498L141.604 33.5329L144.211 33.92C144.642 33.9848 145.073 34.0497 145.502 34.1148L149.327 34.703L151.214 34.9987L156.774 35.8881L160.403 36.4797L172.661 38.4999L176.05 39.0519L179.395 39.5877L182.419 40.0617L184.418 40.368L186.403 40.6658L188.375 40.9546L190.335 41.2337L192.284 41.5025L194.223 41.7605L196.151 42.007L198.071 42.2415L199.982 42.4633C200.618 42.535 201.253 42.6046 201.886 42.6718L203.783 42.8665C227.458 45.2108 249.709 44.1663 277.021 34.4625C282.139 32.644 287.127 30.6881 292.023 28.6636L294.276 27.7247C295.025 27.4102 295.772 27.0944 296.517 26.7775L298.746 25.8236L300.965 24.8644L303.175 23.9016L307.568 21.9707L315.191 18.6066L318.44 17.1838L320.602 16.2454L322.762 15.3168L324.921 14.3995L326.001 13.9455L328.159 13.048L329.239 12.6048L331.399 11.7305C345.088 6.24644 358.906 1.80549 373.82 0.126761L374.999 0Z"
                fill="#F0F2F9"
              />
            </svg>
          </>
        )}
      </div>
    </div>
  );
};

export default Banner;
